import { axiosApiInstance } from "../axios";
import type {
  FinanceInventoryFilters,
  FinanceInventoryResponse,
} from "./inventory-types";

export async function fetchFinanceInventory(
  page = 1,
  search = "",
  filters: FinanceInventoryFilters,
): Promise<FinanceInventoryResponse> {
  const response = await axiosApiInstance.get<FinanceInventoryResponse>(
    "finance/inventory",
    {
      params: {
        page,
        search: search || undefined,
        group_by: filters.groupBy,
        stages: filters.stages.length ? filters.stages : undefined,
        class_ids: filters.classIds.length ? filters.classIds : undefined,
        category_ids: filters.categoryIds.length
          ? filters.categoryIds
          : undefined,
        product_ids: filters.productIds.length ? filters.productIds : undefined,
        warehouses: filters.warehouses.length ? filters.warehouses : undefined,
        locations: filters.locations.length ? filters.locations : undefined,
        rooms: filters.rooms.length ? filters.rooms : undefined,
        valuation_statuses: filters.valuationStatuses.length
          ? filters.valuationStatuses
          : undefined,
        units: filters.units.length ? filters.units : undefined,
      },
    },
  );
  return response.data;
}
